import {
  IconDefinition,
  IconName,
  IconPrefix,
} from "@fortawesome/fontawesome-common-types";

export const faImagesCirclePlus: IconDefinition = {
  prefix: "fac" as IconPrefix,
  iconName: "images-circle-plus" as IconName,
  icon: [
    640,
    512,
    [],
    "e0",
    "M0 120c0-13.3 10.7-24 24-24s24 10.7 24 24v224c0 48.6 39.4 88 88 88h196c6.9 17.5 16.5 33.7 28.3 48H136C60.9 480 0 419.1 0 344V120zm96-24c0-35.3 28.7-64 64-64h352c35.3 0 64 28.7 64 64v115.2c-14.9-7.6-31-13.2-48-16.3V96c0-8.8-7.2-16-16-16H160c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h15.6l68.9-94.2c4.6-6.2 11.7-9.8 19.4-9.8s14.9 3.6 19.4 9.8l12.4 16.9 52.2-79.8c4.4-6.8 12-10.9 20.1-10.9s15.7 4.1 20.1 10.9l22.9 35c-54.2 30-91 87.8-91 154.1 0 5.4.2 10.7.7 16H160c-35.3 0-64-28.7-64-64V96zm96 48c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm160 224c0-79.5 64.5-144 144-144s144 64.5 144 144-64.5 144-144 144-144-64.5-144-144zm64 0c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16z",
  ],
};

export const faFilesCirclePlus: IconDefinition = {
  prefix: "fac" as IconPrefix,
  iconName: "files-circle-plus" as IconName,
  icon: [
    640,
    512,
    [],
    "e0",
    "M0 120c0-13.3 10.7-24 24-24s24 10.7 24 24v256c0 48.6 39.4 88 88 88h192c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V120zm96-56c0-35.3 28.7-64 64-64h165.5c17 0 33.3 6.7 45.3 18.7l58.5 58.5c12 12 18.7 28.3 18.7 45.3v76.1c-17.2 4.9-33.4 12.3-48 21.8v-92.5h-48c-17.7 0-32-14.3-32-32v-48L160 48c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h160c0 16.6 2.3 32.7 6.6 48H160c-35.3 0-64-28.7-64-64V64zm256 304c0-79.5 64.5-144 144-144s144 64.5 144 144-64.5 144-144 144-144-64.5-144-144zm64 0c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16z",
  ],
};

export const faLocationDotArrow: IconDefinition = {
  prefix: "fac" as IconPrefix,
  iconName: "location-dot-arrow" as IconName,
  icon: [
    640,
    512,
    [],
    "e0",
    "M0 192C0 86 86 0 192 0S384 86 384 192c0 2.2-.1 4.4-.2 6.7c-19.6 5.6-37.8 14.5-54 26c4.3-13.7 6.2-24.6 6.2-32.7c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c18.5-23.8 41.7-54.7 64.1-88.2c0 1.5-.1 3-.1 4.5c0 22.2 4.1 43.4 11.6 62.9c-19.7 27.3-38.2 51.1-51.9 68.3c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192zm112 0c0-28.6 15.2-55 40-69.3s55.2-14.3 80 0s40 40.7 40 69.3s-15.2 55-40 69.3s-55.2 14.3-80 0s-40-40.7-40-69.3zm48 0c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32zM288 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm64 0c0 8.8 7.2 16 16 16l89.4 0-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 352 368 352c-8.8 0-16 7.2-16 16z",
  ],
};

export const faDesktopCircleArrowRight: IconDefinition = {
  prefix: "fac" as IconPrefix,
  iconName: "desktop-circle-arrow-right" as IconName,
  icon: [
    640,
    512,
    [],
    "e0",
    "M0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 147.2c-19.5-10-41.1-16.4-64-18.5L512 64 64 64l0 224 275.2 0c-12.3 24-19.2 51.2-19.2 80c0 59.5 29.6 112.1 74.8 144L160 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l69.3 0L240 416 64 416c-35.3 0-64-28.7-64-64L0 64zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm64 0c0 8.8 7.2 16 16 16l89.4 0-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L521.4 352 432 352c-8.8 0-16 7.2-16 16z",
  ],
};

export const faBuildingSlash: IconDefinition = {
  prefix: "fac" as IconPrefix,
  iconName: "building-slash" as IconName,
  icon: [
    640,
    512,
    [],
    "e0",
    "M24.1 0C16.9 0 9.9 3.2 5.1 9.2-3.1 19.6-1.2 34.7 9.2 42.9l124.9 97.9 34.7 27.2 61.2 48 102.1 80 207.3 162.5 61.8 48.4c4.4 3.4 9.6 5.1 14.7 5.1 7.1 0 14.2-3.2 19-9.2 8.2-10.4 6.3-25.5-4.1-33.7L554.9 409.6 512 376 512 64c0-35.3-28.7-64-64-64L192 0c-35.3 0-64 28.7-64 64l0 11-89.2-69.9C34.4 1.7 29.2 0 24.1 0zM176 64c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16l0 274.4-54.2-42.5c8-.9 14.2-7.7 14.2-15.9l0-48c0-8.8-7.2-16-16-16l-48 0 0 0c-8.8 0-16 7.2-16 16l0 12.3-36.1-28.3-61.2-48 33.4 0s0 0 0 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16l0 40-40-31.4 0-48.6zM360 88c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16 0 0 0 0 0 0l48 0s0 0 0 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM128 196.9L128 448c0 35.3 28.7 64 64 64 0 0 0 0 0 0l256 0s0 0 0 0c20.1 0 38-9.3 49.8-23.8l-37.7-29.7c-2.9 3.4-7.3 5.5-12.1 5.5l-80 0 0-64c0-5.7-1-11.2-2.8-16.3l-39.9-31.4c-1.7-.2-3.5-.3-5.3-.3-26.5 0-48 21.5-48 48l0 64-80 0 0 0c-8.8 0-16-7.2-16-16l0-213.3-48-37.8zm88 69.3l0 13.8c0 8.8 7.2 16 16 16 0 0 0 0 0 0l21.8 0-37.8-29.8z",
  ],
};

export const aiPencil: IconDefinition = {
  prefix: "fac" as IconPrefix,
  iconName: "ai-pencil" as IconName,
  icon: [
    212,
    141,
    [],
    "e0",
    "m27 77 6 16 16 6-16 6-6 16-6-16-16-6 16-6zm45-30 5 12 12 5-12 5-5 12-5-12-12-5 12-5zm-20-25 4 10 10 4-10 4-4 10-4-10-10-4 10-4zM76.1 97.225l-5.75 19.525-3.1 10.55c-.625 2.125-.05 4.4 1.5 5.95s3.825 2.125 5.925 1.525l10.575-3.125 19.525-5.75c2.6-.75 5.025-2 7.15-3.625l.075.05.125-.2c.35-.275.675-.55 1-.825.35-.3.675-.625 1-.95l76.05-76.025c5.475-5.475 6.15-13.9 2.05-20.125a16 16 0 0 0-2.05-2.5l-9.85-9.875c-6.25-6.25-16.375-6.25-22.625 0l-76.05 76.05c-.625.625-1.225 1.3-1.775 2l-.2.125.05.075a22.2 22.2 0 0 0-3.625 7.15m86.65-42.475-46.4 46.4-12.4-3.1-3.1-12.4 46.4-46.4zm-71.5 41.975 1.925 7.75c.525 2.15 2.225 3.825 4.375 4.375l7.75 1.925-1.85 2.8c-.65.35-1.325.65-2.025.85l-5.85 1.725-13.725 4 4.025-13.7 1.725-5.85c.2-.7.5-1.4.85-2.025zm54.575-35.05c1.55-1.55 1.55-4.1 0-5.65s-4.1-1.55-5.65 0l-24 24c-1.55 1.55-1.55 4.1 0 5.65s4.1 1.55 5.65 0z",
  ],
};
